export function makeInitialInfoItems(data) {
    const schedule = data?.schedule ?? {};

    return [
        {
            label: "Nome",
            value: schedule?.name ?? "",
        },
        {
            label: "Cadastro",
            value: schedule?.creationdate ?? "",
        },
        {
            label: "Última alteração",
            value: schedule?.updatedate ?? "",
        },
        {
            label: "Natureza",
            value: schedule?.reason ?? "",
        },
        {
            label: "Prioridade",
            value: schedule?.priority ?? "",
        },
        {
            label: "Canal",
            value: schedule?.channel ?? "",
        },
    ];
}

export function makeRequesterItems(data) {
    const schedule = data?.schedule ?? {};

    return [
        {
            label: "Solicitante",
            value: schedule?.contactname ?? "",
        },
        {
            label: "Telefone",
            value: schedule?.contactphone ?? "",
        },
    ];
}
